import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { useTheme } from 'styled-components';
import { StyledBar, StyledLabel, StyledSelect } from './styled';

const InviteServerSelect = ({ value, options, onChange, embedded }) => {
  const theme = useTheme();
  if (isEmpty(options)) return null;

  const selected = options.find((option) => option.value === value) || null;

  return (
    <StyledBar $embedded={embedded}>
      <StyledLabel>Server</StyledLabel>
      <StyledSelect
        classNamePrefix="react-select"
        options={options}
        value={selected}
        onChange={(option) => onChange(option.value)}
        isSearchable={false}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 10000 }),
          menu: (base) => ({
            ...base,
            background: theme.card,
            border: `1px solid ${theme.border}`,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.35)',
            overflow: 'hidden',
          }),
          option: (base, state) => ({
            ...base,
            fontFamily: 'Archivo, sans-serif',
            fontSize: 13,
            fontWeight: 500,
            color: theme.text,
            backgroundColor: state.isSelected
              ? theme.nav
              : state.isFocused
                ? theme.hover
                : theme.card,
          }),
        }}
      />
    </StyledBar>
  );
};

InviteServerSelect.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func.isRequired,
  embedded: PropTypes.bool,
};

InviteServerSelect.defaultProps = {
  value: null,
  options: [],
  embedded: false,
};

export default InviteServerSelect;
